import * as React from 'react';
import * as _ from 'underscore';
import * as $ from 'jquery';

import { IGlob } from '../../../../pdc-platform/src/ts/Glob';
import { store as RMStore, actions as RMActions } from '../flux/glob';

import BooleanField from '../../../../_common/platform/tsx/BooleanField';
import { IRMInstanceState } from '../flux/Store';

const Globalize = require('pdc-platform-Globalize');

require('../../sass-main/pdc-widget-resource-manager.sass');

const DEFAULT_IMAGE_SRC = 'assets/document.jpg';
const SIZES = ['Bytes', 'KBytes', 'MBytes', 'GBytes', 'TBytes', 'PBytes', 'EBytes', 'ZBytes', 'YBytes'];

function formatBytes(bytes: number, decimals) {
    for (var i = 0, r = bytes, b = 1024; r > b; i++) {
        r /= b;
    }

    return `${parseFloat(r.toFixed(decimals))} ${SIZES[i]}`;
}

export default class Resource extends React.Component<
    {
        name?: string;
        resid?: number | string;
        instanceId?;
        view?: number;
        index?: number;
        date?;
        selected?;
        size?: number;
        src?: string;
        glob: IGlob;

        onSelect?(resid: number | string, name: string): void;
        onMultiSelect?(resid: number | string, name: string): void;
        onUnselect?(resid: number | string): void;
    },
    {
        name: string;
        RMState: IRMInstanceState;
    }
> {
    // Drop it.
    public static defaultProps = {
        name: ''
    };

    private _ref: string = '';
    private _ref_text: string = '';
    private references: {} = {};

    constructor(props) {
        super(props);

        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this._ref = 'resouce_item_' + this.props.resid;
        this._ref_text = 'resouce_item_text_' + this.props.resid;
        this.state = {
            name: this.props.name,
            RMState: rmState
        };
    }

    componentDidMount() {
        let _component = this.references[this._ref] as HTMLElement;
        let _element: any = $(_component);
        let _component_text = this.references[this._ref_text] as HTMLElement;

        if (_component_text) {
            if (_component_text.offsetWidth < _component_text.scrollWidth) {
                _element.attr('title', this.props.name);
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.view < 2 && nextProps.view != this.props.view) {
            $('#list-table td').resizable({ disabled: true });
        }
        return true;
    }

    // componentDidUpdate(prevProps, prevState) {
    //     if (this.props.view == 2) {
    //         $('#list-table td, #list-table th').resizable({
    //             disabled: false,
    //             resize: (event, ui) => {
    //                 const col = $(this).index() + 1;
    //                 const RMState = RMStore.getInstanceState(this.props.instanceId);

    //                 $(this)
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .find(
    //                         'li #list-table tr td:nth-child(' + col + '), li #list-table tr th:nth-child(' + col + ')'
    //                     )
    //                     .width(ui.size.width);
    //                 $(this)
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .parent()
    //                     .find(
    //                         'li #list-table tr td:nth-child(' + col + '), li #list-table tr th:nth-child(' + col + ')'
    //                     )
    //                     .find('label')
    //                     .width(ui.size.width);
    //                 this.setState({ RMState: RMState });
    //             }
    //         });
    //     }
    // }

    private handleEditChange = (e) => {
        const RMState = RMStore.getInstanceState(this.props.instanceId);

        this.setState({
            name: e.target.value,
            RMState: RMState
        });
    };

    private handleKeyUp = (e) => {
        if (e.code == 'Escape') {
            this.setState(
                _.extend(RMStore.getInstanceState(this.props.instanceId), {
                    resourceRenaming: -1,
                    name: this.props.name
                })
            );
        }

        if (e.code == 'Enter') {
            RMActions.resourceRenameFinish(this.props.instanceId, this.props.resid.toString(), e.target.value);
        }

        e.stopPropagation();
        e.preventDefault();
    };

    private handleEditBlur = (e) => {
        let _self = this;
        let value = e.target.value;

        if (value !== _self.props.name) {
            this.props.glob.DialogActions.createDialog(
                'Rename resource "' + _self.props.name + '"',
                'Resource "' +
                    _self.props.name +
                    '" will be renamed' + //value +
                    '. Please, confirm this action.',
                () => {
                    RMActions.resourceRenameFinish(_self.props.instanceId, _self.props.resid.toString(), value);
                },
                () => {},
                () => {
                    _self.setState(
                        _.extend(RMStore.getInstanceState(_self.props.instanceId), {
                            resourceRenaming: -1,
                            name: _self.props.name
                        })
                    );
                },
                'confirm',
                {
                    confirmTitle: 'Rename',
                    cancelTitle: null,
                    closeTitle: 'Cancel'
                }
            );
        } else {
            _self.setState(
                _.extend(RMStore.getInstanceState(_self.props.instanceId), {
                    resourceRenaming: -1,
                    name: _self.props.name
                })
            );
        }
    };

    private getNameComponent = () => {
        if (RMStore.getInstanceState(this.props.instanceId).resourceRenaming === this.props.resid) {
            return (
                <input
                    autoFocus
                    onFocus={function (e) {
                        (e.target as HTMLInputElement).select();
                    }}
                    type="text"
                    value={this.state.name}
                    onChange={this.handleEditChange}
                    onBlur={this.handleEditBlur}
                    onKeyUp={this.handleKeyUp}
                />
            );
        } else {
            return this.props.name;
        }
    };

    handleOnClick = () => {
        if (this.props.onSelect != null) {
            this.props.onSelect(this.props.resid, this.props.name);
        }

        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this.setState({
            name: this.props.name,
            RMState: rmState
        });
    };

    handleOnSelect = (value: boolean) => {
        if (value && this.props.onMultiSelect != null) {
            this.props.onMultiSelect(this.props.resid, this.props.name);
        }

        if (value == false && this.props.onUnselect != null) {
            this.props.onUnselect(this.props.resid);
        }

        const rmState = RMStore.getInstanceState(this.props.instanceId);

        this.setState({
            name: this.props.name,
            RMState: rmState
        });
    };

    getHeader = (_class) => {
        if (this.props.index == 0) {
            return (
                <li key={'header_' + this.props.resid} className={_class}>
                    <table id="list-table">
                        <tbody>
                            <tr>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '20px',
                                        minWidth: '20px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '20px'
                                        }}
                                    >
                                        {' '}
                                    </label>
                                </th>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '28px',
                                        minWidth: '28px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '28px'
                                        }}
                                    >
                                        {' '}
                                    </label>
                                </th>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '280px',
                                        minWidth: '150px'
                                    }}
                                >
                                    <label className="resource resource-name" style={{ minWidth: '150px' }}>
                                        {'Name'}
                                    </label>
                                </th>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '200px',
                                        minWidth: '100px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '100px'
                                        }}
                                    >
                                        {'Date'}
                                    </label>
                                </th>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '150px',
                                        minWidth: '100px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '100px'
                                        }}
                                    >
                                        {'Size'}
                                    </label>
                                </th>
                                <th
                                    style={{
                                        paddingRight: '5px',
                                        width: '400px',
                                        minWidth: '200px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '200px'
                                        }}
                                    >
                                        {'Resid'}
                                    </label>
                                </th>
                            </tr>
                        </tbody>
                    </table>
                </li>
            );
        }
    };

    render() {
        const date = Globalize.formatDate(new Date(this.props.date), {
            datetime: 'short'
        });

        let width = 'auto';
        let resourceClass = 'resource-icon';

        if (this.props.view === 1) {
            width = '40px';
        }

        if (this.props.view === 2) {
            width = '20px';
            resourceClass = 'resource-list';
        }

        const _class = resourceClass + (this.props.selected ? ' selected-resource' : '');
        const size = formatBytes(this.props.size ?? 0, 2);
        const image = (
            <img
                style={{ width: width }}
                src={(this.props.src ?? DEFAULT_IMAGE_SRC) + '?' + new Date().getTime()}
                onClick={this.handleOnClick}
            />
        );

        if (this.props.view < 2) {
            return (
                <li
                    ref={(input) => {
                        this.references[this._ref] = input;
                    }}
                    key={this.props.resid}
                    className={_class}
                >
                    <table>
                        <tbody>
                            <tr>
                                <td colSpan={2}>{image}</td>
                            </tr>
                            <tr>
                                <td style={{ paddingRight: '4px' }}>
                                    <BooleanField
                                        title={''}
                                        value={this.props.selected}
                                        allowNull={false}
                                        onChange={this.handleOnSelect}
                                    />
                                </td>
                                <td>
                                    <div>
                                        <label
                                            className="resource resource-name"
                                            ref={(input) => {
                                                this.references[this._ref_text] = input;
                                            }}
                                        >
                                            {this.getNameComponent()}
                                        </label>
                                        <label className="resource">{date}</label>
                                        <label className="resource">{size}</label>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
            );
        } else {
            return [
                this.getHeader(resourceClass),

                <li
                    ref={(input) => {
                        this.references[this._ref] = input;
                    }}
                    key={this.props.resid}
                    className={_class}
                >
                    <table id="list-table">
                        <tbody>
                            <tr>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '20px',
                                        minWidth: '20px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '20px'
                                        }}
                                    >
                                        <BooleanField
                                            title={''}
                                            value={this.props.selected}
                                            allowNull={false}
                                            onChange={this.handleOnSelect}
                                        />
                                    </label>
                                </td>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '28px',
                                        minWidth: '28px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '28px'
                                        }}
                                    >
                                        {image}
                                    </label>
                                </td>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '280px',
                                        minWidth: '150px'
                                    }}
                                >
                                    <label
                                        className="resource resource-name"
                                        ref={(input) => {
                                            this.references[this._ref_text] = input;
                                        }}
                                        style={{ minWidth: '150px' }}
                                    >
                                        {this.getNameComponent()}
                                    </label>
                                </td>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '200px',
                                        minWidth: '100px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '100px'
                                        }}
                                    >
                                        {date}
                                    </label>
                                </td>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '150px',
                                        minWidth: '100px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '100px'
                                        }}
                                    >
                                        {size}&nbsp;bytes
                                    </label>
                                </td>
                                <td
                                    style={{
                                        paddingRight: '5px',
                                        width: '400px',
                                        minWidth: '200px'
                                    }}
                                >
                                    <label
                                        className="resource"
                                        style={{
                                            width: 'auto',
                                            minWidth: '200px'
                                        }}
                                    >
                                        {this.props.resid}
                                    </label>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </li>
            ];
        }
    }
}
